import React from "react";
import "./BrandWordmark.css";

const BrandWordmark = ({ variant = "navbar", className = "", showTagline = false }) => {
  return (
    <span
      className={`brand-wordmark brand-wordmark--${variant} ${className}`.trim()}
      aria-label="CAJobPortal"
    >
      <span className="brand-wordmark-main">
        <span className="brand-wordmark-ca">CA</span>
        <span className="brand-wordmark-job">Job</span>
        <span className="brand-wordmark-portal">Portal</span>
      </span>
      {showTagline && (
        <span className="brand-wordmark-tagline">CA, CS &amp; CMA Jobs</span>
      )}
    </span>
  );
};

export default BrandWordmark;
